import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GenMiniCartComponent } from './mini-cart.component';
import { GenericLinkModule } from '@spartacus/storefront';

@NgModule({
  imports: [
    CommonModule,
    GenericLinkModule,
  ],
  declarations: [GenMiniCartComponent],
  exports: [GenMiniCartComponent],
})
export class GenMiniCartModule {}